import CruciblePiece from './cruciblePiece';
import config from '../config.json';
import { CogwheelsConfig } from '../config';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader';

export class Cogwheels extends CruciblePiece {
  protected _config: CogwheelsConfig;
  protected _baseSpeed: number;
  protected _bigCogs: THREE.Object3D[];
  protected _mediumCogs: THREE.Object3D[];
  protected _smallCogs: THREE.Object3D[];

  constructor() {
    super();
    this._config = config.cogwheels;
    this._baseSpeed = this._config.baseRotationSpeed;
    this._bigCogs = [];
    this._mediumCogs = [];
    this._smallCogs = [];
  }

  setup(gltf: GLTF) {
    // Reset arrays when setting up a new crucible
    this._bigCogs = [];
    this._mediumCogs = [];
    this._smallCogs = [];

    // Reset group object with gltf contents
    this.group = gltf.scene;
    this.group.scale.set(2, 2, 2);

    this.group.traverse((node: any) => {
      if (node.isMesh) {
        node.castShadow = true;
        node.receiveShadow = true;
        if (node.material.map) node.material.map.anisotropy = 16;
      }

      if (node.name === this._config.smallCogsNodeName) {
        this._smallCogs = node.children;
      }

      if (node.name === this._config.mediumCogsNodeName) {
        this._mediumCogs = node.children;
      }

      if (node.name === this._config.bigCogsNodeName) {
        this._bigCogs = node.children;
      }
    });
  }

  animate(timeElapsed: number) {
    this._smallCogs.forEach((child, i) => {
      child.rotation.y += this._baseSpeed * 4 * timeElapsed;
    });

    this._mediumCogs.forEach((child) => {
      child.rotation.y -= this._baseSpeed * 2 * timeElapsed;
    });

    this._bigCogs.forEach((child) => {
      child.rotation.y += this._baseSpeed * timeElapsed;
    });
  }
}
